import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-show-info-text-dialog-component',
  templateUrl: './show-info-text-dialog-component.component.html',
  styleUrls: ['./show-info-text-dialog-component.component.scss']
})
export class ShowInfoTextDialogComponentComponent  extends DialogContentBase {

  constructor( public dialog: DialogRef) {   super(dialog);  }

  @Input() question:string;

  ok(){
        this.dialog.close({ text: 'OK' });
  }

}